import Title from '#/components/common/toast/Title';
import Error from '#/components/common/toast/Error';

import { TradeBust } from '#/api/trade-busts';

interface Props {
  bust: TradeBust;
}

export function TradeBusted({ bust }: Props) {
  return (
    <Error>
      <Title>Trade Busted On-Chain</Title>
      Fill id: {bust.busted_fill_id}
    </Error>
  );
}
